// extracted by mini-css-extract-plugin
export var errorIcon = "_mm-1";
export var nameLogo = "_mm-0";